import { useEffect, useState } from 'react';
import {
  CHALLENGE_DEFAULT_BANNER,
  publicChallengeInfoService,
} from '../../../../../../challenges';

type UseChallengeBannerProps = {
  challengeId: number;
};

type UseChallengeBannerReturn = {
  challengeBannerUrl: string | null;
};

export const useChallengeBanner = ({
  challengeId,
}: UseChallengeBannerProps): UseChallengeBannerReturn => {
  const [challengeBannerUrl, setChallengeBannerUrl] = useState<string | null>(null);

  const getChallengeBanner = async () => {
    const response = await publicChallengeInfoService.getChallengeInfo(challengeId);

    setChallengeBannerUrl(
      response.mobileBanner?.fileUrl || CHALLENGE_DEFAULT_BANNER.MOBILE,
    );
  };

  useEffect(() => {
    getChallengeBanner();
  }, [challengeId]);

  return { challengeBannerUrl };
};
